var initOverlay = require('./openseadragon-fabricjs-overlay');

var OpenSeadragon = require('./openseadragon/openseadragon');

var fabric = require('./fabric/fabric.adapted').fabric;

module.exports = {
  initOverlay: initOverlay,
  OpenSeadragon: OpenSeadragon,
  fabric: fabric
};